/**
 * @author mi
 * @date 2019/2/19
 * @project kaoshizhongxin-pc
 */

export const MixinMetaInfo = {
  data () {
    return {
      pageName: this.$route.meta.title
    }
  },
  metaInfo () {
    let vm = this
    return {
      title: '组卷在线',
      titleTemplate (title) {
        return (vm.pageName ? `${title} - ${vm.pageName}` : `${title}`) || '组卷在线'
      }
    }
  }
}
